
var sandboxOn = Number(process.env.VUE_APP_AUTHORIZE_SANDBOX_ON)
module.exports = {
  apiURL: process.env.VUE_APP_API_URL,
  port: 1024,
  publicPath: process.env.VUE_APP_PUBLIC_PATH,
  debugMode: process.env.VUE_APP_DEBUG_MODE,
  authorizeScript: sandboxOn ? process.env.VUE_APP_AUTHORIZE_SCRIPT_SANDBOX : process.env.VUE_APP_AUTHORIZE_SCRIPT, // choose one from above
  authorizeCredentials: {
    loginId: sandboxOn ? process.env.VUE_APP_AUTHORIZE_LOGIN_ID_SANDBOX : process.env.VUE_APP_AUTHORIZE_LOGIN_ID,
    clientKey:
       sandboxOn ? process.env.VUE_APP_AUTHORIZE_CLIENT_KEY_SANDBOX : process.env.VUE_APP_AUTHORIZE_CLIENT_KEY
  }
}
